import { render, staticRenderFns } from "./ModalSelecionaAluno.vue?vue&type=template&id=c58854ee"
import script from "./ModalSelecionaAluno.vue?vue&type=script&lang=js"
export * from "./ModalSelecionaAluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports